import styled from '@emotion/styled';
import { TableVariant } from '../../types';

export const TableWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const OuterContainer = styled.div<{ $variant?: TableVariant }>`
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  background-color: ${p =>
    p.$variant === 'transparent' ? 'transparent' : p.theme.palette.bg.primary};
  width: 100%;
  height: 100%;
`;

export const OverLay = styled.div<{ abs?: boolean; $headerHeight?: number }>`
  position: ${p => (p.abs ? 'absolute' : 'relative')};
  ${p =>
    p.abs &&
    `left: 0; right: 0; bottom: 0; top: ${
      p.$headerHeight ?? 0
    }px; width: 100%; height: calc(100% - ${p.$headerHeight ?? 0}px);`}
  z-index: 2;
  overflow: hidden;
  box-sizing: border-box;
  contain: layout paint;
`;

/** Fills overlay exactly; scrolls when zoomed. Content stays below header (overlay clips). */
export const EmptyStateScrollRegion = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: auto;
  overflow-x: hidden;
  padding: ${p => p.theme.s.lg} ${p => p.theme.s.md} ${p => p.theme.s.xl};
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

/** Wraps empty state; content can grow so when zoomed user can scroll to see image and text. */
export const EmptyStateInnerWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: auto;
  flex-shrink: 0;
`;

export const Container = styled.div`
  height: 100%;
  width: 100%;
  overflow-x: auto;
  overflow-y: auto;
`;

export const TableStyles = styled.table<{
  fillerPosition: number;
  remainingWidth: number;
  rowHeight: number;
}>`
  width: 100%;
  border-spacing: 0px;

  .frozen {
    position: sticky;
    display: flex;
    align-items: center;
    z-index: 4;
  }
  th.frozen > div {
    width: 100%;
  }

  tr {
    display: flex;
    width: fit-content;
    height: ${p => p.rowHeight}px;

    td.selector:not(.selected) > span {
      visibility: hidden;
    }
    :hover {
      td.selector > span {
        visibility: visible;
      }
    }
  }

  tr th:last-child {
    border-top: 0;
  }
`;
